import React from 'react';
import { Github, Linkedin, Twitter, Mail, ArrowUp } from 'lucide-react';
import { personalInfo, socialLinks, navLinks } from '../mock';

const iconMap = { Github, Linkedin, Twitter, Mail };

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="portfolio-footer">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          {/* Left - Brand */}
          <div className="flex flex-col gap-4 max-w-sm">
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2.5 w-fit"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              aria-label="Back to top"
            >
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center font-bold text-xs text-white"
                style={{ background: 'var(--gradient-text)', fontFamily: "'JetBrains Mono', monospace" }}
              >
                JM
              </div>
              <span
                className="font-semibold text-sm"
                style={{ color: 'var(--text-primary)', fontFamily: "'JetBrains Mono', monospace" }}
              >
                joo.memoria
              </span>
            </button>
            <p
              className="text-xs"
              style={{ color: 'var(--text-muted)', lineHeight: 1.7, maxWidth: '300px' }}
            >
              Full Stack Web Developer based in the Philippines. Available for new projects.
            </p>
            {/* Social icons */}
            <div className="flex gap-2.5">
              {socialLinks.map((link) => {
                const Icon = iconMap[link.icon];
                if (!Icon) return null;
                return (
                  <a
                    key={link.label}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon-btn"
                    title={link.label}
                    style={{ width: '34px', height: '34px' }}
                  >
                    <Icon size={14} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Center - Nav Links */}
          <div className="flex flex-col gap-3">
            <p
              className="text-xs mono mb-1"
              style={{ color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase' }}
            >
              Navigation
            </p>
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-left text-sm"
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text-secondary)',
                  fontFamily: "'Inter', sans-serif",
                  padding: 0,
                  transition: 'color 0.2s ease',
                  width: 'fit-content'
                }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-secondary)'; }}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Right - CTA */}
          <div className="flex flex-col gap-4 items-start md:items-end">
            <div className="available-badge">
              <span className="available-dot" />
              Open to Work
            </div>
            <p
              className="text-xs"
              style={{ color: 'var(--text-muted)', maxWidth: '220px', textAlign: 'right', lineHeight: 1.6 }}
            >
              Let's build something great together.
            </p>
            <a
              href={`mailto:${personalInfo.email}`}
              className="btn-accent gap-2 px-5 py-2.5 text-xs"
              style={{ textDecoration: 'none', border: 'none' }}
            >
              <Mail size={13} />
              {personalInfo.email}
            </a>

            {/* Scroll to top */}
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-xs"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: 'var(--text-muted)',
                fontFamily: "'JetBrains Mono', monospace",
                transition: 'color 0.2s ease',
                padding: 0
              }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--accent)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted)'; }}
            >
              Back to top <ArrowUp size={12} />
            </button>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="mt-10 pt-6 flex items-center justify-center"
          style={{ borderTop: '1px solid var(--border-color)' }}
        >
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            &copy; {new Date().getFullYear()} Joo James Memoria. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
